import { useCifraClient } from "../cifra-client";

const { cifraClient } = useCifraClient();

export default {
  get(options) {
    return cifraClient.get('/api_publica/v1/transporte/turnos', options);
  },
  asientosLibres(idTurno, fechaInicio, fechaFin = null, options = null) {
    const defaults = { params: { fechaInicio } };
    if (fechaFin) {
      defaults.params.fechaFin = fechaFin;
    }
    const opts = { ...defaults, ...options };
    if (Array.isArray(idTurno)) {
      opts.params.turno_id = idTurno;
      return cifraClient.get('/api_publica/v1/transporte/turnos/asientos_libres', opts);
    }

    return cifraClient.get(`/api_publica/v1/transporte/turnos/${idTurno}/asientos_libres`, opts);
  },
};
